import { Button, Flex, Link } from "@chakra-ui/react";
import React from "react";

const Navbar = () => {
  return (
    <Flex
      bg="white"
      w="100vw"
      height="80px"
      boxShadow="md"
      px="15px"
      justifyContent="space-between"
      alignItems="center"
      zIndex={1000}
      pos="relative"
    >
      <a href="https://appointmentscanner.com?ref=waittimes-nav-logo">
        <img
          src="/locations/logo.svg"
          alt="Appointment Scanner Logo"
          width="300px"
          height="50px"
        />
      </a>
      <Button
        variant="primary"
        as={Link}
        href="https://appointmentscanner.com?ref=waittimes-nav"
        bg="linear-gradient(65deg, #FF9083 0, #FF6250 100%)"
        color="white"
        size="lg"
      >
        Sign up
      </Button>
    </Flex>
  );
};

export default Navbar;
